module.exports = __webpack_public_path__ + "/images/shop/icon/catalog/brake_system.svg";